export const maskingClassNames = 'fs-mask sensitive-information';
